import { render, staticRenderFns } from "./globalMsg.vue?vue&type=template&id=6852c870&scoped=true&"
import script from "./globalMsg.vue?vue&type=script&lang=js&"
export * from "./globalMsg.vue?vue&type=script&lang=js&"
import style0 from "./globalMsg.vue?vue&type=style&index=0&id=6852c870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6852c870",
  null
  
)

component.options.__file = "globalMsg.vue"
export default component.exports